import TransitionTemplate from '../../html/components/transition.html'

import Component from '../shared/component'

export const Transition = Component('v-transition', {
  template: TransitionTemplate,
  props: {
    appear: {
      type: Boolean,
      default: false
    },
    css: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: null,
      valid: [
        'transition',
        'animation'
      ]
    },
    mode: {
      type: String,
      default: null,
      valid: [
        'out-in',
        'in-out'
      ]
    }
  },
  data () {
    return {
      entered: false
    }
  },
  methods: {
    beforeEnter (element) {
      this.entered = false
      this.$emit('before-enter', element)
    },

    enter (element) {
      setTimeout(() => {
        this.entered = true
      }, 16)
      this.$emit('enter', element)
    },

    afterEnter (element) {
      this.$emit('after-enter', element)
    },

    beforeLeave (element) {
      this.entered = true
      this.$emit('before-leave', element)
    },

    leave (element) {
      setTimeout(() => {
        this.entered = false
      }, 16)
      this.$emit('leave', element)
    },

    afterLeave (element) {
      this.$emit('after-leave', element)
    }
  }
})
